export const state = () => ({
    isCookieBannerVisible: false,
    isCookieBannerAllowedToBeVisible: false,
});

export const mutations = {
    setCookieBannerVisibility(state, payload) {
        state.isCookieBannerVisible = payload;
    },
    setIsCookieBannerAllowedToBeVisible(state, payload) {
        state.isCookieBannerAllowedToBeVisible = payload;
    },
};

export const actions = {
    openBanner({ commit }) {
        commit('setCookieBannerVisibility', true);
    },
    closeBanner({ commit }) {
        commit('setCookieBannerVisibility', false);
    },
};
